import { CLOSE, TOGGLE } from './mutations';

export default {
  namespaced: true,
  state() {
    return {
      expanded: {},
    };
  },
  getters: {
    allSlideoutsClosed(state) {
      return !Object.keys(state.expanded).filter((key) => state.expanded[key] === true).length;
    },
  },
  mutations: {
    [CLOSE](state, id) {
      state.expanded[id] = false;
    },
    [TOGGLE](state, id) {
      state.expanded[id] = !state.expanded[id];
    },
  },
};
